import { render } from "./TextCta.vue?vue&type=template&id=1e51e124"
import script from "./TextCta.vue?vue&type=script&lang=js"
export * from "./TextCta.vue?vue&type=script&lang=js"

import "./TextCta.vue?vue&type=style&index=0&id=1e51e124&lang=scss"
script.render = render

export default script